import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {WaterWashWizardDialog} from "./WaterWashWizardDialog";
import {WaterWashList} from "./WaterWashList";
import {useLocation, useParams} from "react-router-dom";

export function WaterWashBranchPage() {
    const myData = useContext(TrackVASContext);
    const { branchId } = useParams();
    const location = useLocation();
    const [branchInfo, setBranchInfo] = useState(location.state || {});
    const [showWizard, setShowWizard] = useState(false);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "Water Wash",
            path: "/waterWash",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "Create Water Wash",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: () => setShowWizard(true),
                },
            ],
        });

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    const handleSave = () => {
        setRefreshCounter(prev => prev + 1);
        setShowWizard(false);
    };

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>
                {branchInfo.branchName ? `Water Wash - ${branchInfo.branchName}` : 'Water Wash Records'}
            </PageTitle>

            <WaterWashList branchId={branchId} refreshCounter={refreshCounter} />

            <WaterWashWizardDialog
                show={showWizard}
                handleClose={() => setShowWizard(false)}
                onSave={handleSave}
                branchId={branchId}
                branchName={branchInfo.branchName || 'Selected Branch'}
            />
        </>
    );
}
